module.exports = "/images/vendor/flag-icon-css/flags/1x1/au.svg?9b18ee0449e1b5cd1c783fda310eed4f";